module.exports = __webpack_public_path__ + "img/case_icon4.9d789d1f.png";